export class OTA_RateQualifier {
    public corpDiscountNmbr: string;
    public promotionCode: string;
    public promotionVendorCode: string;
    public rateQualifier: string;
}